import React, { useState } from 'react';
import { 
  Database, 
  Brain, 
  Cloud, 
  Code, 
  BarChart3, 
  Settings,
  Cpu 
} from 'lucide-react';
import technologies from '../images/Technologies.png';

const Skills = ({ data }) => {
  const [activeCategory, setActiveCategory] = useState(0);

  const categoryIcons = {
    'Machine Learning': Brain,
    'Deep Learning & NLP': Cpu,
    'Data Engineering': Database,
    'Programming': Code,
    'Cloud & DevOps': Cloud,
    'Data Visualization': BarChart3,
    'Databases': Settings
  };

  return (
    <section id="skills" className="skills-section">
      <div className="skills-container">
        <div className="section-header">
          <span className="label">TECHNICAL EXPERTISE</span>
          <h2 className="title-big">SKILLS</h2>
        </div>

        <div className="skills-content">
          <div className="skills-navigation">
            {data.categories.map((category, index) => {
              const Icon = categoryIcons[category.name] || Code;
              return (
                <button
                  key={index}
                  onClick={() => setActiveCategory(index)}
                  className={`skill-nav-item ${activeCategory === index ? 'active' : ''}`}
                >
                  <Icon size={20} />
                  <span className="text-body">{category.name}</span>
                  <span className="label-small">{category.technologies.length} TOOLS</span>
                </button>
              );
            })}
          </div>

          <div className="skills-display">
            <div className="skills-header">
              <div className="category-info">
                <h3 className="text-regular">{data.categories[activeCategory].name}</h3>
                <span className="label-small">
                  {data.categories[activeCategory].technologies.length} TECHNOLOGIES
                </span>
              </div>
            </div>

            <div className="skills-grid">
              {data.categories[activeCategory].technologies.map((tech, index) => (
                <div key={index} className="skill-item">
                  <span className="text-body">{tech}</span>
                </div>
              ))}
            </div>

            <div className="skills-summary">
              <div className="summary-stats">
                <div className="stat-item">
                  <span className="stat-number ">
                    {data.categories.reduce((sum, cat) => sum + cat.technologies.length, 0)}
                  </span>
                  <span className="stat-label label-small">TOTAL TECHNOLOGIES</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number ">{data.categories.length}</span>
                  <span className="stat-label label-small">SKILL CATEGORIES</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">1+</span>
                  <span className="stat-label label-small">YEARS EXPERIENCE</span>
                </div>
              </div>
                  <div className="image-container">
      <img src={technologies} alt="Technologies logos" className="tech-image" />
    </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;